export default __webpack_public_path__ + "static/media/2.fe1a0092.jpg";